module.exports = " <div _v-7800d7eb=\"\"> <a class=notification-box href=/notification target=_blank _v-7800d7eb=\"\"> <i class=\"notification-box-icon fa fa-bell-o\" v-el:bell=\"\" _v-7800d7eb=\"\"></i> <span class=\"notification-box-hint badge glow\" v-show=notificationNum v-text=\"notificationNum < 50 ? notificationNum : 50 \" _v-7800d7eb=\"\"></span> </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.3.1@vue-loader/lib/template-rewriter.js?id=_v-7800d7eb!./~/_vue-loader@8.3.1@vue-loader/lib/selector.js?type=template&index=0!./app/scaffold/notification-box.vue
// module id = 278
// module chunks = 0